import { makeAutoObservable } from 'mobx';

class CountdownStore {
    isCountdownComplete: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    setCountdownComplete = (value: boolean) => {
        this.isCountdownComplete = value;
    };
}

export const countdownStore = new CountdownStore();
